@if ($visible()) {
    <div class="cm-action-items">
        <ng-content select="[cm-action-items]"> </ng-content>
    </div>
}
